import { FileIcon, TemplatesIcon } from '@bp/ui-components';
import type { FC } from 'react';
import styles from './TeachingUnitsTree.module.scss';
import { TreeItemType } from './types';

type TeachingUnitsTreeDropPreviewProps = { text: string; type?: TreeItemType };

export const TeachingUnitsTreeDropPreview: FC<TeachingUnitsTreeDropPreviewProps> = ({ text, type }) => {
  return (
    <div className={styles['drop-preview']}>
      <div className={styles.icon}>
        {type === TreeItemType.teachingUnit ? <FileIcon /> : <TemplatesIcon className='svg-icon mr-1' />}
      </div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};
